import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// Conversation log: who spoke to the client, how, when, and what was said.
// The author is always the logged-in user (set by the server).
const TYPES = [['call', '📞 Call'], ['meeting', '🤝 Meeting'], ['site_visit', '🏗️ Site visit'], ['whatsapp', '💬 WhatsApp'], ['note', '📝 Note']];
const label = (t) => (TYPES.find((x) => x[0] === t) || [t, '📝 Note'])[1];

const ClientTimeline = ({ apiBase, clientId }) => {
  const [rows, setRows] = useState([]);
  const [type, setType] = useState('call');
  const [text, setText] = useState('');
  const [important, setImportant] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const load = useCallback(() => {
    axios.get(`${apiBase}/client-docs/${clientId}/remarks`).then((r) => setRows(r.data || [])).catch(() => {});
  }, [apiBase, clientId]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!text.trim()) { setErr('Write what was discussed.'); return; }
    setBusy(true); setErr('');
    try {
      await axios.post(`${apiBase}/client-docs/${clientId}/remarks`, { remark_type: type, remark_text: text, is_important: important });
      setText(''); setImportant(false); load();
    } catch (e) {
      setErr(e.response?.status === 403 ? 'You are not allowed to add remarks.' : (e.response?.data?.error || 'Could not save.'));
    } finally { setBusy(false); }
  };

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '14px', padding: '16px', marginBottom: '16px' }}>
      <div style={{ fontSize: '16px', fontWeight: 800, marginBottom: '10px' }}>Conversation log</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
        {TYPES.map(([k, l]) => (
          <button key={k} onClick={() => setType(k)}
            style={{ padding: '8px 12px', borderRadius: '999px', border: `1.5px solid ${type === k ? '#2563eb' : '#d1d5db'}`, background: type === k ? '#eff6ff' : '#fff', color: type === k ? '#1d4ed8' : '#374151', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>{l}</button>
        ))}
      </div>
      <textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="What was discussed? e.g. Interested in 2 BHK on a high floor, will visit Sunday with family"
        style={{ width: '100%', minHeight: '70px', padding: '10px 12px', border: '1.5px solid #d1d5db', borderRadius: '10px', fontSize: '15px', boxSizing: 'border-box', fontFamily: 'inherit' }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', gap: '8px', flexWrap: 'wrap' }}>
        <label style={{ fontSize: '14px', display: 'flex', gap: '6px', alignItems: 'center' }}>
          <input type="checkbox" checked={important} onChange={(e) => setImportant(e.target.checked)} /> Mark important
        </label>
        <button onClick={add} disabled={busy}
          style={{ padding: '10px 18px', borderRadius: '10px', border: 'none', background: '#2563eb', color: '#fff', fontSize: '15px', fontWeight: 700, cursor: 'pointer', opacity: busy ? 0.6 : 1 }}>
          {busy ? 'Saving…' : 'Add to log'}
        </button>
      </div>
      {err && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '8px 12px', borderRadius: '8px', fontSize: '14px', marginTop: '8px' }}>{err}</div>}

      <div style={{ marginTop: '14px' }}>
        {rows.length === 0 && <div style={{ fontSize: '14px', color: '#9ca3af' }}>Nothing logged yet.</div>}
        {rows.map((r) => (
          <div key={r.id} style={{ borderLeft: `3px solid ${r.is_important ? '#dc2626' : '#e5e7eb'}`, padding: '6px 0 6px 12px', marginBottom: '8px' }}>
            <div style={{ fontSize: '13px', color: '#6b7280' }}>
              <b style={{ color: '#111827' }}>{label(r.remark_type)}</b> · {r.created_by_name || 'Team'} · {new Date(r.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
              {r.is_important && <span style={{ color: '#dc2626', fontWeight: 700 }}> · Important</span>}
            </div>
            <div style={{ fontSize: '15px', whiteSpace: 'pre-wrap', marginTop: '2px' }}>{r.remark_text || r.remark}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientTimeline;
